const  arr=[  
    {
        "name": "中国",
        "dial_code": "+86",
        "code": "CN",
		"priority": 1
    },    
    {
        "name": "中國香港",
        "dial_code": "+852",
        "code": "HK",
		"priority": 1
    },
    {
        "name": "中國澳門",
        "dial_code": "+853",
        "code": "MO",
		"priority": 1
    },
    {
        "name": "中國臺灣",
        "dial_code": "+886",
        "code": "TW",
		"priority": 1
    },
    {
        "name": "Việt Nam",
        "dial_code": "+84",
        "code": "VN",
		"priority": 2
    },
    {
        "name": "한국",
        "dial_code": "+82",
        "code": "KR",
		"priority": 3
    },
    {
        "name": "Australia",
        "dial_code": "+61",
        "code": "AU",
		"priority": 4
    },
    {
        "name": "United States",
        "dial_code": "+1",
        "code": "US",
		"priority": 4
    },    
];
 
export default arr;